// Module
var code = "<div class=\"btn-group\"><select class=\"btn\" ng-model=\"newFilter.user_value\"><option disabled=\"disabled\" value=\"\">Value</option><option value=\"true\">Yes</option><option value=\"false\">No</option></select></div>\n";
// Exports
module.exports = code;